import React from "react";

import icon_Main from "../../../assets/icons/icon_closet.svg";
import icon_Property from "../../../assets/icons/icon_mobiliario.svg";
import icon_Finishes from "../../../assets/icons/icon_acabados.svg";
import icon_Quote from "../../../assets/icons/icon_cotiza2.svg";

interface Props {
  menu: string;
  propertyType: any;
  setMenu: (value: string) => void;
}

const BottombarMain: React.FC<Props> = ({ menu, propertyType, setMenu }) => {
  return (
    <div className={`bottombar-main-container`}>
      <div className={`bottombar-main-container-scroll`}>
        <div className={`bottombar-main-button ${menu === 'Apartamento' ? 'selected':''}`} onClick={() => setMenu('Apartamento')}>
          <img className={`bottombar-main-button-logo ${menu === 'Apartamento' ? 'selected':''}`} src={icon_Main} draggable={false} alt=''/>
          <div className={`bottombar-main-button-text ${menu === 'Apartamento' ? 'selected':''}`}>Apartamento</div>
        </div>
        { propertyType.id !== "ObraGris" &&
          <div className={`bottombar-main-button ${menu === 'Mobiliario' ? 'selected':''}`} onClick={() => setMenu('Mobiliario')}>
            <img className={`bottombar-main-button-logo ${menu === 'Mobiliario' ? 'selected':''}`} src={icon_Property} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${menu === 'Mobiliario' ? 'selected':''}`}>Mobiliario</div>
          </div>
        }
        { propertyType.id !== "ObraGris" &&
          <div className={`bottombar-main-button ${menu === 'Acabados' ? 'selected':''}`} onClick={() => setMenu('Acabados')}>
            <img className={`bottombar-main-button-logo ${menu === 'Acabados' ? 'selected':''}`} src={icon_Finishes} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${menu === 'Acabados' ? 'selected':''}`}>Acabados</div>
          </div>
        }
        <div className={`bottombar-main-button ${menu === 'Cotizacion' ? 'selected':''}`} onClick={() => setMenu('Cotizacion')}>
          <img className={`bottombar-main-button-logo ${menu === 'Cotizacion' ? 'selected':''}`} src={icon_Quote} draggable={false} alt=''/>
          <div className={`bottombar-main-button-text ${menu === 'Cotizacion' ? 'selected':''}`}>Cotiza</div>
        </div>
      </div>
    </div>
  );
};

export default BottombarMain;